import { xml2ast } from '@utils/ast';
import { video23Parsers } from './spec.23video.js';
import { boxParsers } from './spec.box.js';
import { fontParsers } from './spec.font.js';
import { iGuideHtmlNodeParsers } from './spec.html.js';
import { preparseCustomBlockTags } from './util.prepare-custom-block-tag.js';

function iGuideHtmlToAst(html) {
  return xml2ast(preparseCustomBlockTags(html, ["factbox", "quotebox", "questionbox"]).replace(/\[(audio|video) id="([^"]+)"\]/gi, '<medialibrary$1 id="$2" />').replace(/\[23-video id="(.+?)"+?\]/gi, '<video23 data="$1" />'), {
    ...iGuideHtmlNodeParsers,
    ...fontParsers,
    ...boxParsers,
    ...video23Parsers
  }, "text/html");
}

export { iGuideHtmlToAst };
//# sourceMappingURL=util.html-to-ast.js.map
